import { useNavigate } from 'react-router-dom'
import { ClipboardList, Plus, CalendarDays, Users, CheckCircle2, Clock } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useMobileData } from '../MobileDataContext'
import { MTopbar } from '../MobileLayout'

function fmtDate(d?: string, locale?: string) {
  if (!d) return '—'
  try {
    return new Date(d).toLocaleDateString(locale ?? 'en', { day: '2-digit', month: 'short', year: 'numeric' })
  } catch {
    return d
  }
}

export default function MExamList() {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation('pages')
  const { exams, className, getGrades } = useMobileData()

  return (
    <>
      <MTopbar title={t('mobile.examList.title')} subtitle={t('mobile.examList.nExams', { count: exams.length })} />
      <div className="m-scroll">
        <div className="m-page">
          {exams.length === 0 ? (
            <div className="m-empty">
              <ClipboardList />
              <div>{t('mobile.examList.empty')}</div>
            </div>
          ) : (
            <div className="m-stack">
              {exams.map((exam) => {
                const graded = getGrades(exam.id).length > 0
                return (
                  <button
                    key={exam.id}
                    className="m-exam-card"
                    onClick={() => navigate(`/m/exams/${exam.id}/setup`)}
                  >
                    <div className="m-exam-card__icon">
                      <ClipboardList size={22} />
                    </div>
                    <div className="m-exam-card__body">
                      <div className="m-exam-card__title">{exam.session_name}</div>
                      <div className="m-exam-card__meta">
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                          <Users size={13} /> {className(exam.class_id)}
                        </span>
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                          <CalendarDays size={13} /> {fmtDate(exam.test_date, i18n.language)}
                        </span>
                      </div>
                    </div>
                    {graded ? (
                      <span className="m-pill m-pill--success">
                        <CheckCircle2 size={13} /> {t('mobile.examList.graded')}
                      </span>
                    ) : (
                      <span className="m-pill m-pill--neutral">
                        <Clock size={13} /> {t('mobile.examList.ready')}
                      </span>
                    )}
                  </button>
                )
              })}
            </div>
          )}
        </div>
      </div>
      <button className="m-fab" onClick={() => navigate('/m/exams/new')}>
        <Plus size={20} /> {t('mobile.examList.newExam')}
      </button>
    </>
  )
}
